// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__annpX","fileBtn":"File_fileBtn__21aGT","closeBtn":"File_closeBtn__3gXA9","fileSelected":"File_fileSelected__3MSTa","disabled":"File_disabled__1HfwR"};